"use strict";

export function writeText_(txt) {
    return navigator.clipboard.writeText(txt)
}
